// Local Utils
import {
  validUrl,
  validateIPv4
} from 'utils/validate';

// Local const
import {
  defaultSelectedRadius,
  defaultAccountingDefinition
} from '../const';

export const getInitSelectedRadius = ({
  selectedRadius = {}
}) => {

  const result = {
    ...defaultSelectedRadius,
    ...(selectedRadius ?? {}),
    primary: {
      ...defaultSelectedRadius.primary,
      ...(selectedRadius?.primary ?? {})
    },
    secondary: {
      ...defaultSelectedRadius.secondary,
      ...(selectedRadius?.secondary ?? {})
    }
  }

  if (!result?.primary?.accounting) result.primary.accounting = structuredClone(defaultSelectedRadius.primary.accounting);
  if (!result?.secondary?.accounting) result.secondary.accounting = structuredClone(defaultSelectedRadius.secondary.accounting);

  return result;
}

export const getIsAuthServerInvalid = ({
  authServer
}) => {
  let isInvalid = false;

  if (!authServer || (!validUrl(authServer) && !validateIPv4(authServer))) isInvalid = true;

  return isInvalid;
}

export const getIsPortInvalid = ({
  port
}) => {
  let isInvalid = false;

  if (!port || (+port < 1 || +port > 65535)) isInvalid = true;

  return isInvalid;
}

export const getIsFormInvalid = ({
  selectedRadius
}) => {
  let isInvalid = false;

  const { name, primary, secondary } = selectedRadius;
  const { accounting: primaryAccounting } = primary;
  const { accounting: secondaryAccounting } = secondary;

  if (!name) isInvalid = true;

  // Primary
  if (getIsAuthServerInvalid({ authServer: primary?.authenticateServer })) isInvalid = true;
  if (getIsPortInvalid({ port: primary?.port })) isInvalid = true;
  if (!primary?.secret || !primary?.authenticationType || !primary?.accountingType) isInvalid = true;
  if (primary?.accountingType === defaultAccountingDefinition.independent.value) {
    if (getIsAuthServerInvalid({ authServer: primaryAccounting?.accountingServer })) isInvalid = true;
    if (getIsPortInvalid({ port: primaryAccounting?.port })) isInvalid = true;
    if (!primaryAccounting?.secret || !primaryAccounting?.authenticationType) isInvalid = true;
  }

  // Secondary ( optional )
  if (secondary?.authenticateServer && getIsAuthServerInvalid({ authServer: secondary?.authenticateServer })) isInvalid = true;
  if (secondary?.port && getIsPortInvalid({ port: secondary?.port })) isInvalid = true;
  if (!secondary?.authenticationType || !secondary?.accountingType) isInvalid = true;
  if (secondary?.accountingType === defaultAccountingDefinition.independent.value) {
    if (secondaryAccounting?.accountingServer && getIsAuthServerInvalid({ authServer: secondaryAccounting?.accountingServer })) isInvalid = true;
    if (secondaryAccounting?.port && getIsPortInvalid({ port: secondaryAccounting?.port })) isInvalid = true;
    if (!secondaryAccounting?.authenticationType) isInvalid = true;
  }

  return isInvalid;
};

export const getCleanPayload = ({
  selectedRadius
}) => {
  if (!selectedRadius) return selectedRadius;

  const { primary, secondary } = selectedRadius;
  const { accounting: primaryAccounting } = primary;
  const { accounting: secondaryAccounting } = secondary;

  const isPrimaryIndependentMode = primary.accountingType === defaultAccountingDefinition.independent.value;
  const isSecondaryIndependentMode = secondary.accountingType === defaultAccountingDefinition.independent.value;

  // Primary : Required.
  // Secondary : Optional.
  const payload = {
    ...selectedRadius,
    primary: {
      ...primary,
      port: primary.port ? +primary.port : null,
      accounting: {
        ...primaryAccounting,
        port: primaryAccounting.port ? +primaryAccounting.port : null,
      }
    },
    secondary: {
      ...secondary,
      authenticateServer: secondary.authenticateServer ?? "",
      port: secondary.port ? +secondary.port : 0,
      secret: secondary.secret ?? "",
      accounting: {
        ...secondaryAccounting,
        accountingServer: secondaryAccounting.accountingServer ?? "",
        port: secondaryAccounting.port ? +secondaryAccounting.port : 0,
        secret: secondaryAccounting.secret ?? "",
      }
    }
  }

  if (!isPrimaryIndependentMode) delete payload.primary.accounting;
  if (!isSecondaryIndependentMode) delete payload.secondary.accounting;

  return payload;
}